// extracted by mini-css-extract-plugin
module.exports = {"inputBlock":"InputBlock_inputBlock__tg35j","title":"InputBlock_title__zpj0y","input":"InputBlock_input__3W1Wb","isColumnInput":"InputBlock_isColumnInput__1WsSP"};